export const hashOptions = [
  { id: "contact_first_name", value: "Contact first name" },
  { id: "contact_last_name", value: "Contact last name" },
  { id: "contact_full_name", value: "Contact full name" },
  { id: "contact_email", value: "Contact email" },
  { id: "contact_phone", value: "Contact phone" },
  { id: "agent_first_name", value: "Agent first name" },
  { id: "agent_last_name", value: "Agent last name" },
  { id: "agent_full_name", value: "Agent full name" },
];

export const hashOptionMap = {
  "#Contact first name": "{{ contact.firstName }}",
  "#Contact last name": "{{ contact.lastName }}",
  "#Contact full name": "{{ contact.firstName }} {{ contact.lastName }}",
  "#Contact email": "{{ contact.emails[0] }}",
  "#Contact phone": "{{ contact.phones[0] }}",
  "#Agent first name": "{{ agent.firstName }}",
  "#Agent last name": "{{ agent.lastName }}",
  "#Agent full name": "{{ agent.firstName }} {{ agent.lastName }}",
};

export const parseHashOptions = (text: string) => {
  for (const [key, value] of Object.entries(hashOptionMap)) {
    text = text.replace(new RegExp(`${key}`, "g"), value);
  }

  return text;
};
